export { default as TreeBushA_LOD3 } from './Tree_Bush_A_LOD3.glb';
export { default as TreeBushC_LOD3 } from './Tree_Bush_C_LOD3.glb';
export { default as TreeFlowerA_LOD3 } from './Tree_Flower_A_LOD3.glb';
export { default as TreeFlowerB_LOD3 } from './Tree_Flower_B_LOD3.glb';
export { default as TreeFlowerC_LOD3 } from './Tree_Flower_C_LOD3.glb';
export { default as TreeFlowerD_LOD3 } from './Tree_Flower_D_LOD3.glb';
export { default as TreeNormalA_LOD3 } from './Tree_Normal_A_LOD3.glb';
export { default as TreeNormalB_LOD3 } from './Tree_Normal_B_LOD3.glb';
export { default as TreeNormalC_LOD3 } from './Tree_Normal_C_LOD3.glb';
export { default as TreeNormalD_LOD3 } from './Tree_Normal_D_LOD3.glb';
